import React from 'react';
import SEO from '../components/SEO/SEO';
import { BreadcrumbSchema } from '../components/SEO/StructuredData';
import SoftwarePage from '../components/SoftwarePage/SoftwarePage';

function Software(): JSX.Element {
  return (
    <>
      <SEO title="Software Solutions" description="Custom software development services by Cool & Care: web development, mobile apps, digital marketing, UI/UX design, and AR/VR solutions." keywords="software development DRC, web development, mobile app development, digital marketing, AR VR" />
      <BreadcrumbSchema items={[{ name: 'Software', url: '/software' }]} />
      <SoftwarePage />
    </>
  );
}

export default Software;


